import { createContext } from 'react';
import { Dayjs } from 'dayjs';

import {
  AuditLogEntry,
  AuditLogPaging,
} from '@totem/components/services/remoteAccess/auditLog/types';

interface Context {
  loading: boolean;
  data: AuditLogEntry[];
  paging: AuditLogPaging;
  startDate: Dayjs | null;
  endDate: Dayjs | null;
  userSearch: string;
  assigneeSearch: string;
  roleSearch: string;
  onStartDateChange: (date: Dayjs | null) => void;
  onEndDateChange: (date: Dayjs | null) => void;
  onUserSearchChange: (value: string) => void;
  onAssigneeSearchChange: (value: string) => void;
  onRoleSearchChange: (value: string) => void;
  onPageChange: (page: number, pageSize: number) => void;
  onRefresh: () => void;
}

export default createContext<Context>({
  loading: false,
  data: [],
  paging: { page: 1, pageSize: 50, totalRecords: 0 },
  startDate: null,
  endDate: null,
  userSearch: '',
  assigneeSearch: '',
  roleSearch: '',
  onStartDateChange: () => {},
  onEndDateChange: () => {},
  onUserSearchChange: () => {},
  onAssigneeSearchChange: () => {},
  onRoleSearchChange: () => {},
  onPageChange: () => {},
  onRefresh: () => {},
});
